import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ProfessionalHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="16601" id="treatments-overview" className="relative w-full overflow-hidden bg-primary py-[89px] flex items-center justify-center min-h-[85vh] text-foreground">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-40 bg-[#264256] z-10" aria-hidden="true" />
      <div className="absolute inset-0 pointer-events-none opacity-50 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626927/img/technical_blueprint_watermark.png)] bg-cover bg-center bg-no-repeat mix-blend-overlay" aria-hidden="true" />

      {}
      <div ref={ref} className={cn("relative z-20 container mx-auto px-6 flex flex-col items-center text-center max-w-5xl transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        {}
        <span className="font-default text-[12px] text-accent-foreground uppercase tracking-widest mb-8 block font-semibold">
          EU Cross-Border Healthcare Directive
        </span>

        {}
        <h1 className="font-default font-bold text-5xl md:text-[60px] leading-[1.1] text-white tracking-normal mb-8 max-w-4xl">
          Specialist spine surgery and pain management in Lithuania.
        </h1>

        {}
        <p className="font-default font-medium text-lg md:text-[20px] text-white/90 leading-relaxed max-w-2xl mb-12">
          Procedures performed by experienced neurosurgeons and pain specialists. Costs reimbursable through the EU Cross-Border Directive for Irish public patients.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-5 w-full sm:w-auto">
          <Button asChild className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-10 text-sm uppercase tracking-widest hover:tracking-[0.06em] transition-all duration-300 border border-ring shadow-[0_0_15px_rgba(101,209,157,0.3)]">
            <Link to="#">
              Request a consultation
            </Link>
          </Button>
          
          <Button asChild className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-10 text-sm uppercase tracking-widest hover:tracking-[0.06em] transition-all duration-300 border border-ring shadow-[0_0_15px_rgba(101,209,157,0.3)]">
            <Link to="#">
              See our procedures
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}